import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";
import type { Organization, OrganizationUpdatePayload } from "./organization.models";

@Injectable({
  providedIn: 'root'
})
export class OrganizationApi {
  private readonly httpService = inject(HttpService);

  getOrganization(id: string) {
    return this.httpService.get(`organization/${id}`, false);
  }

  getCurrentOrganization() {
    return this.httpService.get('organization/me', false);
  }

  listOrganizations() {
    return this.httpService.get('organization', false);
  }

  createOrganization(payload: Pick<Organization, 'name' | 'email' | 'phone' | 'address' | 'is_active'>) {
    return this.httpService.post('organization', payload, false);
  }

  updateOrganization(payload: OrganizationUpdatePayload) {
    return this.httpService.put(`organization/${payload.id}`, payload.organization, false);
  }

  generateCredentials(id: string) {
    return this.httpService.get(`organization/generate_key_and_secret/${id}`, false);
  }

  setOrganizationActive(id: string, isActive: boolean) {
    return this.httpService.put(`organization/enable_disable/${id}`, { is_active: isActive }, false);
  }
}
